var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAllWithWhiteOutlinedCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 3.71094C13.2611 3.71094 3.71094 13.2611 3.71094 25C3.71094 36.7389 13.2611 46.2891 25 46.2891C36.7389 46.2891 46.2891 36.7389 46.2891 25C46.2891 13.2611 36.7389 3.71094 25 3.71094ZM25 0.976562C38.2678 0.976562 49.0234 11.7322 49.0234 25C49.0234 38.2678 38.2678 49.0234 25 49.0234C11.7322 49.0234 0.976562 38.2678 0.976562 25C0.976562 11.7322 11.7322 0.976562 25 0.976562Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9079 34.5241L11.7188 24.335L14.1365 21.9172L21.9079 29.5159L35.8965 15.5273L38.3143 17.9451L21.9079 34.5241Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllWithWhiteOutlinedCircle);
export default __webpack_public_path__ + "static/media/select_all_with_white_outlined_circle.d9095be25940b8ff8a221ec3e00298e6.svg";
export { ForwardRef as ReactComponent };